if (!customElements.get("category-section")) {
  class CategorySection extends HTMLElement {
    constructor() {
      super();
      this.tabs = Array.from(this.querySelectorAll("[data-category-tab]"));
      this.panels = Array.from(this.querySelectorAll("[data-category-panel]"));
      this.scenes = Array.from(this.querySelectorAll("[data-category-scene]"));
      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
    }

    connectedCallback() {
      this.addEventListener("click", this.onClick);
      this.addEventListener("keydown", this.onKeydown);
      if (Shopify.designMode) document.addEventListener("shopify:block:select", this.onBlockSelect);
      if (this.tabs[0]) this.activate(this.tabs[0], false);
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.onClick);
      this.removeEventListener("keydown", this.onKeydown);
      document.removeEventListener("shopify:block:select", this.onBlockSelect);
    }

    onClick(event) {
      const tab = event.target.closest("[data-category-tab]");
      if (tab && this.contains(tab)) this.activate(tab, false);
    }

    onKeydown(event) {
      const tab = event.target.closest("[data-category-tab]");
      if (!tab || (event.key !== "ArrowLeft" && event.key !== "ArrowRight")) return;
      event.preventDefault();
      const index = this.tabs.indexOf(tab);
      const direction = event.key === "ArrowRight" ? 1 : -1;
      const next = this.tabs[(index + direction + this.tabs.length) % this.tabs.length];
      this.activate(next, true);
    }

    onBlockSelect(event) {
      if (event.detail.sectionId !== this.dataset.sectionId) return;
      const scene = event.target.closest("[data-category-scene]");
      if (!scene || !scene.dataset.categoryScene) return;
      const tab = this.tabs.find((item) => item.dataset.categoryTab === scene.dataset.categoryScene);
      if (tab) this.activate(tab, false);
    }

    activate(tab, focus) {
  const category = tab.dataset.categoryTab;

  this.tabs.forEach((item) => {
    const active = item === tab;
    item.classList.toggle("is-active", active);
    item.setAttribute("aria-selected", active ? "true" : "false");
    item.tabIndex = active ? 0 : -1;
  });

  this.panels.forEach((panel) => {
    const active = panel.dataset.categoryPanel === category;
    panel.hidden = !active;
  });

  const hasCategoryScenes = this.scenes.some(
    (scene) => scene.dataset.categoryScene === category
  );

  this.scenes.forEach((scene) => {
    const assigned = scene.dataset.categoryScene;
    scene.hidden =
      hasCategoryScenes &&
      assigned !== "" &&
      assigned !== category;
  });

  if (focus) {
    tab.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    });

    tab.focus({
      preventScroll: true
    });
  }
}
  }
  customElements.define("category-section", CategorySection);
}
